export default __webpack_public_path__ + "4533d80457dd3351d0b50b94ac8022c6.svg";